import Mixin from "../../mixin.js";
import Label from "./Label.js";
import InputText from "./InputText.js";
import Funnel from "../../services/funnel-service.js";
import Utils from "../../services/utils-service.js";

// import vuejsDatepicker from "vuejs-datepicker";
import vuejsDatepicker from '@sum.cumo/vue-datepicker';

import moment from 'moment';

const template = `
    <div v-show="fs.display(input)">
        <qt-label :iuid="iuid" v-if="!input.inline && !input.basic"></qt-label>
        <vue-datepicker
            :class="input.inline ? 'inline-datepicker' : ''"
            v-if="input.inline"
            :inline="true"
            :disabled-dates="InlineDisabledDates"
            :id="input.uid"
            :name="input.uid"
            v-model="selectedDate"
            :format="dateFormat"
            :required="input.validation && input.validation.required"
            :validation_text="input.validation && input.validation.validation_text"
            v-bind="validationRules"
            :typeable=false
            :open-date="convertToDate(input.value)"
            :data-uid="input.uid"
            :show-edge-dates="false"
        ></vue-datepicker>

        <input
            v-else-if="isSimpleYearPicker"
            :id="iuid"
            class="simple-datepicker"
            :name="input.element_name"
            type="text"
            :placeholder="simpleDatePlaceholder"
            :pattern="simpleDatePattern"
            :required="input.validation.required"
            :disabled="input.disabled"
            :readonly="input.readonly"
            :value="input.value"
            @input="exec($event, input)"
            @blur="persistSimpleDate($event, input)"
            v-maska="simpleDateMask"
            v-bind="simpleDateValidation"
            :data-uid="input.uid"
            :aria-required="input.validation.required"
            :aria-labelledby="'label_'+input.uid"
            :aria-describedby="input.uid + '_error'"
        />

        <vue-datepicker
            v-else-if="input.year_only"
            minimum-view="year"
            :disabled-dates="disabledDates"
            :id="input.uid"
            :name="input.uid"
            v-model="selectedYear"
            :format="dateFormat"
            :required="input.validation && input.validation.required"
            :validation_text="input.validation && input.validation.validation_text"
            v-bind="validationRules"
            :typeable=false
            :calendar-button="true"
            :open-date="disabledDates.from"
            :data-uid="input.uid"
            :show-edge-dates="false"
        >
            <template #calendarBtn>
                <i class="iconic iconic-calendar-sm"/>
            </template>
        </vue-datepicker>

        <qt-input-text
            v-else-if="input.basic"
            :iuid="iuid"
        />
        <input
            v-else-if="isSimplePicker"
            :id="iuid"
            class="simple-datepicker"
            :name="input.element_name"
            type="text"
            :placeholder="simpleDatePlaceholder"
            :pattern="simpleDatePattern"
            :required="input.validation.required"
            :disabled="input.disabled"
            :readonly="input.readonly"
            :value="input.value"
            @input="exec($event, input)"
            @blur="persistSimpleDate($event, input)"
            v-maska="simpleDateMask"
            v-bind="simpleDateValidation"
            :data-uid="input.uid"
            :aria-required="input.validation.required"
            :aria-labelledby="'label_'+input.uid"
        />
        <vue-datepicker
            v-else
            :ref="'dp_'+ input.uid"
            :id="input.uid"
            :name="input.uid"
            v-model="selectedDate"
            :format="dateFormat"
            :initial-view="initialView"
            :required="input.validation && input.validation.required"
            :validation_text="input.validation && input.validation.validation_text"
            :class="'date-fix ' + this.ref"
            :placeholder="input.placeholder"
            v-bind="validationRules"
            :typeable=false
            :disabled-dates="disabledDates"
            :open-date="disabledDates.from"
            :data-uid="input.uid"
            :calendar-button=true
            :show-edge-dates="false"
            :aria-describedby="input.uid + '_error'"
            :aria-labelledby="'label_'+input.uid"
        >
            <template #calendarBtn>
                <i class="iconic iconic-calendar-sm"/>
            </template>
        </vue-datepicker>
        <div class="error-here" :id="input.uid+'_error'" role="alert" aria-live="assertive"></div>
    </div>
`;
// check coverage days +8 default ||||         iconic-calendar-sm is the calendar icon, removed it to fix the duplicated icon but refferencing here in case i need to add it back -G
export default {
    name: 'qt-input-date',
    template,
    props: ['iuid'],
    mixins: [Mixin],
    components: {
        'qt-label': Label,
        'qt-input-text': InputText,
        'vue-datepicker': vuejsDatepicker
    },
    data: function () {
        return {
            raw_value: '',
            isFocused: false
        }
    },
    watch: {
        "input.value": function (newVal, oldVal) {
            if (this.isSimplePicker) {
                if (newVal == '') {
                    this.$store.commit('UPDATE_FUNNEL_ELEM', { iuid: this.input.uid, key: 'raw_value', val: '' });

                    var self = this;
                    this.$nextTick(() => {
                        const elem = document.querySelector(`#${self.input.uid}`);
                        if (elem) {
                            elem.focus();
                        }
                    });
                }
                if (newVal != '' && this.permittedDatePattern(newVal))
                    this.processDateFormatting();
            }
        },
        raw_value: function (newVal, oldVal) {
            if (newVal) {
                this.$store.commit('UPDATE_FUNNEL_ELEM', { iuid: this.input.uid, key: 'raw_value', val: this.raw_value });
            }
        },
        "input.basic": function (newVal, oldVal) {
            if (newVal == false && oldVal == true) {
                var self = this;
                this.$nextTick(function () {
                    const refId = `dp_${self.iuid}`;
                    // self.$refs[refId].showCalendar();
                    // self.$refs[refId].$el.querySelector('input').focus();
                });
            }
        }
    },
    computed: {
        fs: function () {
            return new Funnel({ ctx: this.$store, router: this.$router });
        },
        sdp: function () {
            const uid = 'in_is_simple_datepicker';
            return this.$store.getters.funnel.elements[uid];
        },
        isSimplePicker: function () {
            return (this.sdp && Utils.isTruthy(this.sdp.value));
        },
        isSimpleYearPicker: function () {
            return Utils.isTruthy(this.input.year_only) && this.isSimplePicker;
        },
        initialView: function () {
            if (this.input.inline) {
                return 'month'
            } else {
                return 'year'
            }
        },
        selectedDate: {
            get() {
                let date = this.$store.getters.funnel.elements[this.iuid].value;

                if (date) {
                    return date.replace(/-/g, '/');
                } else {
                    // If no date and we're on the coverage start page, default to +8 days
                    if (this.input.uid === 'in_coverage_start_date') {
                        date = moment().add(8, 'days').format('YYYY/MM/DD');
                    }
                }

                return date;
            },
            set(date) {
                self = this;
                this.$nextTick(function () {
                    console.log(`Raw selected date is : ${date}`);
                    const d = new Date(date);
                    const val = Utils.formatDate(d);

                    self.$store.commit('UPDATE_FUNNEL_ELEM', { iuid: self.input.uid, key: 'value', val: val });
                    if (self.$refs && self.$refs[self.ref]) {
                        self.close()
                    }
                    const e = { type: 'change' };
                    const input = self.$store.getters.funnel.elements[self.input.uid];
                    const args = { skipUpdate: true, manualEvent: true };
                    self.exec(e, input, args);
                });
            }
        },
        selectedYear: {
            get() {
                const year = this.$store.getters.funnel.elements[this.iuid].value
                console.log(year);
                return year ? year + '/01/01' : ''
            },
            set(year) {
                self = this;
                this.$nextTick(function () {
                    console.log(`Raw selected year is : ${year}`);
                    const d = new Date(year);
                    const y = d.getFullYear();
                    let DD = y + "/01/01"
                    self.$store.commit('UPDATE_FUNNEL_ELEM', { iuid: self.input.uid, key: 'value', val: y });

                    if (self.input.collectRawValue) {
                        self.$store.commit('UPDATE_FUNNEL_ELEM', { iuid: self.input.uid, key: 'raw_value', val: DD });
                    }

                    if (self.$refs && self.$refs[self.ref]) {
                        self.close()
                    }
                });
            }
        },
        disabledDates: function () {
            var thisYear = new Date().getFullYear()
            var thisMonth = new Date().getMonth()
            var thisDay = new Date().getDate()
            let maxDate, minDate;

            if (!Utils.isEmpty(this.input.validation.enable_days)) {
                var from = new Date();
                var to = new Date();

                // e.g past 90 days. TODO: refactor to accommodate future dates?
                const pastDays = this.input.validation.enable_days + 1;
                from.setDate(from.getDate() - pastDays);
                to.setDate(to.getDate() - 1);

                maxDate = from;
                minDate = to;
            } else {
                var minAge = thisYear - this.input.validation.minimum

                if (this.input.validation.max_year_element != undefined) {
                    var maxAge = thisYear - (thisYear - this.$store.getters.funnel.elements[this.input.validation.max_year_element].value)

                    if (this.input.validation.max_allow_full_year != undefined && this.input.validation.max_allow_full_year == true) {
                        thisMonth = 0
                        thisDay = 1
                    }
                } else {
                    var maxAge = thisYear - this.input.validation.maximum
                }
                maxDate = new Date(maxAge, thisMonth, thisDay);
                minDate = new Date(minAge, thisMonth, thisDay);
            }

            return {
                to: maxDate,
                from: minDate
            }
        },
        InlineDisabledDates: function () {
            let fromYear, fromMonth, fromDay, toYear, toMonth, toDay

            if (this.input.validation.minimum != undefined) {
                let today = new Date()
                today.setDate(today.getDate() + this.input.validation.minimum)
                toYear = today.getFullYear()
                toMonth = today.getMonth()
                toDay = today.getDate()
            }

            if (this.input.validation.maximum != undefined) {
                let today = new Date()
                today.setDate(today.getDate() + this.input.validation.maximum)
                fromYear = today.getFullYear()
                fromMonth = today.getMonth()
                fromDay = today.getDate()
            }

            return {
                to: new Date(toYear, toMonth, toDay),
                from: new Date(fromYear, fromMonth, fromDay)
            }
        },
        splitDate: function () {
            if (this.input.value) {
                return this.input.value.split("/")
            }
        },
        computedMonth: function () {
            if (this.splitDate) {
                return this.splitDate[0]
            }

        },
        computedDay: function () {
            if (this.splitDate) {
                return this.splitDate[1]
            }

        },
        computedYear: function () {
            if (this.splitDate) {
                return this.splitDate[2]
            }

        },
        validationRules: function () {
            // v-bind="validationRules"
            return this.input.validation
        },
        input: function () {
            return this.$store.getters.funnel.elements[this.iuid];
        },
        computedMask: function () {
            return this.input.validation.mask
        },
        ref: function () {
            return 'dp_' + this.input.uid
        },
        dateVal: function () {
            return new Date()
        },
        dateFormat: function () {
            if (this.input.year_only) {
                return 'yyyy'
            }
            return 'yyyy-MM-dd'
        },
        simpleDatePlaceholder: function () {
            let text = 'MM/DD/YYYY';
            if (this.input.year_only)
                text = 'YYYY'
            return text;
        },
        simpleDateMask: function () {
            let mask = '##/##/####';
            if (this.input.year_only)
                mask = '####'
            return mask;
        },
        simpleDatePattern: function () {
            // add pattern if  for year only
            return this.input.input_pattern
        },
        prefillMaskPattern: function () {
            return /\*\*\/\*\*\/|\*\*-\*\*-/;
        },
        completeDateStr: function () {
            let pattern = Utils.$simpleDatePattern;
            if (this.input.year_only)
                pattern = /\d{4}/;
            return pattern;
        },
        simpleDateValidation: function () {
            let validation = this.input.validation;
            if (!Utils.isEmpty(this.input.validation['data-msg-sdpMinAge']))
                validation = this.generateDateValidationDurationRange(this.input);
            if (!Utils.isEmpty(this.input.validation['data-msg-sdpMinDay']))
                validation = this.generateDateValidationDayRange(this.input);
            return validation;
        }
    },
    mounted: function () {
        $('.vdp-datepicker__calendar-button').attr('tabindex', '-1');
        document.addEventListener('keyup', this.handleKeyup);
        this.processDateFormatting();
        this.handleIIFE();
    },
    methods: {
        handleKeyup(event) {
            if (!Utils.isObjEmpty(this.$refs[this.ref])) {
                if (event.key === 'Tab' && this.$refs[this.ref].isOpen) {
                    this.close();
                }
            }
        },
        customFormatter(format) {
            return moment().format(format);
        },
        open: function (ev) {
            if (!Utils.isObjEmpty(this.$refs[this.ref]) && this.$refs[this.ref].isOpen) {
                return
            }
            else {
                if (this.selectedDate) { return }
                // this.$refs[this.ref].showCalendar();

                //scroll to bottom of the calendar when opening only on mobile wip - G 
                if (this.fs.isMobile()) {
                    for (let index = 0; index < document.querySelectorAll('.vdp-datepicker__calendar').length; index++) {
                        setTimeout(function () {
                            console.log('scrolled up, calendar off screen');
                            console.log(document.querySelectorAll('.vdp-datepicker__calendar')[index].attributes['style'].value != "display: none;");
                            if (document.querySelectorAll('.vdp-datepicker__calendar')[index].attributes['style'].value != "display: none;") {
                                document.querySelectorAll('.vdp-datepicker__calendar')[index].scrollIntoView({ block: "center", inline: "center", behavior: "smooth" })
                            }
                        }, 50)
                    }
                }
            }
        },
        close: function (ev) {
            console.log(this.ref);
            if (!Utils.isObjEmpty(this.$refs[this.ref])) {
                this.$refs[this.ref].close(true);
            }
        },
        commitModalDateSelected: function (date) {
            this.dateSelected(date, 'modal');
        },
        calendarOpened: function () {

            var id = this.input.id
            var elem = document.querySelector('#' + id);
            var datepicker = document.querySelector('.vdp-datepicker__calendar');

            $('p').filter(function () {
                return $(this).css('color') == '#333';
            }).css('color', '#444');

            datepicker.style.width = elem.width;

        },
        convertToDate: function (dateValue) {
            let dateObj

            if (dateValue != "") {
                dateObj = new Date(dateValue + " 00:00:00")
            }
            else {
                dateObj = new Date()
            }

            return dateObj
        },
        permittedDatePattern: function (val) {
            return (
                this.completeDateStr.test(val)
                || this.prefillMaskPattern.test(val)
            );
        },
        processDateFormatting: function () {
            if (this.input.value && this.isSimplePicker) {

                let dStrUS = this.input.value;
                let dStrIntnl = this.input.value;
                if (!this.isSimpleYearPicker) {
                    dStrUS = this.changeToUSDateStyle(this.input.value);
                    dStrIntnl = this.changeToInternationalDateStyle(this.input.value);
                }

                this.$store.commit('UPDATE_FUNNEL_ELEM', { iuid: this.input.uid, key: 'value', val: dStrUS });
                this.$store.commit('UPDATE_FUNNEL_ELEM', { iuid: this.input.uid, key: 'raw_value', val: dStrIntnl });
            }
        },
        persistSimpleDate: function (event, input) {
            var val = event.target.value;
            if (val) {
                let dateStrIntnl = val;
                if (!this.isSimpleYearPicker)
                    dateStrIntnl = this.changeToInternationalDateStyle(val);

                if (!Utils.isEmpty(dateStrIntnl)) {
                    this.$store.commit('UPDATE_FUNNEL_ELEM', { iuid: this.input.uid, key: 'raw_value', val: dateStrIntnl });
                    this.exec(event, input, { skipUpdate: true });
                }
            }
        },
        changeToInternationalDateStyle: function (dateStr) {
            let dStrIntnl = '';
            if (!Utils.isEmpty(dateStr)) {
                const date = new Date(dateStr);
                if (this.prefillMaskPattern.test(dateStr)) {
                    dStrIntnl = dateStr;
                } else if (!isNaN(date.getTime())) {
                    dStrIntnl = date.toISOString().slice(0, 10);
                }
            }
            return dStrIntnl;
        },
        changeToUSDateStyle(dateStr) {
            let dStrUS = '';
            if (!Utils.isEmpty(dateStr)) {
                const date = new Date(dateStr.replace(/-/g, '\/'));
                if (this.prefillMaskPattern.test(dateStr)) {
                    dStrUS = dateStr;
                } else if (!isNaN(date.getTime())) {
                    const month = String(date.getMonth() + 1).padStart(2, '0');
                    const day = String(date.getDate()).padStart(2, '0');
                    const year = date.getFullYear();

                    dStrUS = `${month}/${day}/${year}`;
                }
            }
            return dStrUS;
        },
        generateDateValidationDurationRange(input) {
            let v = input.validation;

            let simpleDPV = {
                'data-rule-sdpMinAge': v.minimum
            };
            const cYear = new Date().getFullYear();
            let maxi = v.maximum;
            let maxYear = cYear - maxi;
            let duration = { maxi, maxYear };
            this.getMaxDurationBasedOnPredicateYearElem(v.max_year_element, duration);

            const mxMsgProp = 'data-msg-sdpMaxAge';
            let maxMsg = Utils.replaceStr(v[mxMsgProp], '%valid_year%', duration.maxYear);
            if (duration.maxYear > cYear) {
                maxMsg = v['data-msg-sdpMinAge'];
            }

            simpleDPV['maximum'] = duration.maxi;
            simpleDPV['data-rule-sdpMaxAge'] = duration.maxi;
            simpleDPV[mxMsgProp] = maxMsg;
            return { ...v, ...simpleDPV };
        },
        getMaxDurationBasedOnPredicateYearElem(uid, duration = {}) {
            const elems = this.$store.getters.funnel.elements;
            if (uid && !Utils.isObjEmpty(elems[uid]) && !Utils.isObjEmpty(duration)) {
                const cYear = new Date().getFullYear();

                const elem = elems[uid];
                const stcDfltMaxYear = cYear - elem.validation.maximum;
                const ueDfltMaxYear = elem.value;
                const allwDfltMaxYear = Math.max(stcDfltMaxYear, ueDfltMaxYear);
                const allwDfltMaxi = cYear - allwDfltMaxYear;

                duration.maxi = Math.min(duration.maxi, allwDfltMaxi);
                duration.maxYear = Math.max(allwDfltMaxYear, duration.maxYear);
            }
            return duration;
        },
        generateDateValidationDayRange(input) {
            let v = input.validation;

            let simpleDPV = {
                'data-rule-sdpMinDay': v.minimum,
                'data-rule-sdpMaxDay': v.maximum
            };
            return { ...v, ...simpleDPV };
        }
    }
};
